var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconcontactsphonehome = function SvgIconcontactsphonehome(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/contacts/icon.contacts.phone.home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/contacts/icon.contacts.phone.home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,12 C9.66666667,8.26927083 12.5,6.40390625 12.5,6.40390625 C12.5,6.40390625 15.3323206,8.26927083 20.9969618,12 L20.9969618,22 C16.9989873,22 15,22 15,22 C15,22 15,17.45625 15,17.45625 C15,17.45625 10,17.45625 10,17.45625 C10,17.45625 10,22 10,22 C10,22 8,22 4,22 L4,12 Z",
    id: "Rectangle",
    stroke: "#09BE86",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,11 C8.66666667,5.66666667 12.5,3 12.5,3 C12.5,3 16.3333333,5.66666667 24,11",
    id: "Line",
    stroke: "#09BE86",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 7,
    x2: 6,
    y2: 3,
    id: "Line-2",
    stroke: "#09BE86",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconcontactsphonehome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.contacts.phone.home.d033debde4ea972424adc8201148ef17.svg";